'use client'
import { User } from '@/helpers/types/User'
import { useCurrentUser } from '@/hooks/userGuestUser'
import React, { createContext, useContext, useEffect, useState } from 'react'

interface UserContextType {
  user: User | null
  setUser: (user: User | null) => void
  userPageLoading: boolean
  setUserPageLoading: (userPageLoading: boolean) => void
}

const UserContext = createContext<UserContextType | undefined>(undefined)

export const useUser = () => {
  const context = useContext(UserContext)
  if (!context) {
    throw new Error('useUser must be used within a UserProvider')
  }
  return context
}
type CurrentUserResponse = {
  data: User | null
  error: Error | null
  isLoading: boolean
}

export const UserProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [user, setUser] = useState<User | null>(null)
  const [userPageLoading, setUserPageLoading] = useState(true)
  const [count, setCount] = useState(0)

  const {
    data: currentUser,
    error: currentUserError,
    isLoading,
  } = useCurrentUser()

  useEffect(() => {
    if (!currentUser) setUserPageLoading(true)
    setUserPageLoading(isLoading)
  }, [isLoading, currentUser])

  useEffect(() => {
    console.log('Checking currentUser:', currentUser)
    console.log('Is Loading:', isLoading)

    if (!isLoading) {
      if (currentUser?.data) {
        console.log('setUser:', currentUser)
        setUser(currentUser.data)
      } else {
        if (count < 2) {
          setCount(count + 1)
          //getGuestUser.mutate();
        }
      }
    } else {
      console.log('loading')
    }
  }, [currentUser, isLoading])

  return (
    <UserContext.Provider
      value={{ user, setUser, userPageLoading, setUserPageLoading }}
    >
      {children}
    </UserContext.Provider>
  )
}
